import { render } from "./SbmCeoDashboard.vue?vue&type=template&id=28f924e0&scoped=true"
import script from "./SbmCeoDashboard.vue?vue&type=script&lang=js"
export * from "./SbmCeoDashboard.vue?vue&type=script&lang=js"

import "./SbmCeoDashboard.vue?vue&type=style&index=0&id=28f924e0&lang=css"
import "./SbmCeoDashboard.vue?vue&type=style&index=1&id=28f924e0&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f924e0"]])

export default __exports__